export default {
  props: ["value", "disabled"],
  model: {
    prop: "value",
    event: "input"
  },
  computed: {
    sliderValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
